module.exports = __webpack_public_path__ + "static/img-12.ecf41736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/office_img/img-12.jpg
// module id = 897
// module chunks = 41802369688294